/* 
 * File: src/client/updateNotification/UpdateProvider.jsx
 * Descrizione: Context Provider che utilizza il custom hook per fornire lo stato e la funzione di aggiornamento.
 */

import React, { createContext } from 'react';
import useUpdateNotification from './useUpdateNotification';

export const UpdateNotificationContext = createContext({
  updateAvailable: false,
  handleUpdate: () => {}
});

export const UpdateProvider = ({ children }) => {
  const { updateAvailable, handleUpdate } = useUpdateNotification();

  return (
    <UpdateNotificationContext.Provider value={{ updateAvailable, handleUpdate }}>
      {children}
    </UpdateNotificationContext.Provider>
  );
};
